/* @flow */
export default {
  datiIngressoSistemaRiscaldamento: `(typeKey) => {
    const type = this.values[typeKey];

    const config = this.config.demo_prospetto;

    const body = [
      [
        {
          text: "Tipologia"
        },
        {
          text: type,
          style: "cellData"
        }
      ],
      [
        {
          text: "Costo Impianto Iva esclusa"
        },
        {
          text: config.costo_iva_esc.toFixed(2) + " €",
          style: "cellData"
        }
      ],
      [
        {
          text: "Costo Impianto Iva inclusa (10%)"
        },
        {
          text: config.costo_iva_inc.toFixed(2) + " €",
          style: "cellData"
        }
      ]
    ];

    return {
      widths: ["66%", "34%"],
      body
    };
  }`,
  datiIngressoFinanziaria: `(typeKey, financingYearsKey) => {
    const type = this.values[typeKey];
    const financingYears = this.values[financingYearsKey];

    const config = this.config.demo_prospetto.anni_finanziamento[financingYears.toString()];

    const importoTotaleFinanz = config.importo_mensile * 12;

    const body = [
      [
        {
          text: "Importo Annuale",
        },
        {
          text: importoTotaleFinanz.toFixed(2) + " €",
          style: "cellData"
        }
      ],
      [
        {
          text: "Importo Mensile "
        },
        {
          text: config.importo_mensile.toFixed(2) + " €",
          style: "cellData"
        }
      ],
      [
        {
          text: "Anni Durata Finanziamento"
        },
        {
          text: financingYears,
          style: "cellData"
        }
      ]
    ];

    return {
      widths: ["66%", "34%"],
      body
    };
  }`
};
